import React, { useMemo } from 'react';
import Tab from 'react-bootstrap/Tab';
import { useTranslation } from 'react-i18next';

import ContainerTabs from '../../../components/TabsContainer/TabsContainer';
import AccountNotification from '../AccountNotification/AccountNotification';
import AccountSettings from '../AccountSettings/AccountSettings';
import CSVImport from '../Network/CSVImport/CSVImport';
import ImportHistory from '../Network/ImportHistory/ImportHistory';
import Network from '../Network/Network';
import LinkedInImportZip from '../Network/SyncSources/LinkedInImportZip/LinkedInImportZip';
import SyncSources from '../Network/SyncSources/SyncSources';
import LinkedinImport from '../Profile/LinkedinImport/LinkedinImport';
import Profile from '../Profile/Profile';

const NETWORK_SUB_TABS = {
  'sync-sources': SyncSources,
  'csv-import': CSVImport,
  'linkedin-import-zip': LinkedInImportZip,
  'csv-import-history': ImportHistory,
  'linkedin-import-history': ImportHistory,
};

const AccountTabs = ({ tab, subTab }) => {
  const { t } = useTranslation('common');
  const RenderNetworkSubTab = useMemo(() => {
    const Component = NETWORK_SUB_TABS[subTab];
    if (Component) {
      return <Component />;
    }
    return <Network />;
  }, [subTab]);

  return (
    <ContainerTabs tab={tab} tabsKey="account">
      <Tab eventKey="profile" title={t('tabs.profile')}>
        {subTab === 'linkedin-import' ? <LinkedinImport /> : <Profile />}
      </Tab>
      <Tab eventKey="network" title={t('tabs.network')}>
        {RenderNetworkSubTab}
      </Tab>
      <Tab eventKey="settings" title={t('tabs.settings')}>
        <AccountSettings />
      </Tab>
      <Tab eventKey="notifications" title={t('tabs.notifications')}>
        <AccountNotification />
      </Tab>
    </ContainerTabs>
  );
};

export default AccountTabs;
